import * as React from 'react'
import { Anchor, AnchorProps } from '../state/AnchorNext'
import { PlacementNS, Omit } from '../utils/types'
import Portal from './Portal'

/* TYPES */

export interface OverlayProps extends Omit<AnchorProps, 'overlay'> {
  shrink?: boolean
}

export const Overlay = React.forwardRef<HTMLElement, OverlayProps>(
  (
    {
      canFlip = true,
      children,
      padding = 2,
      placement = PlacementNS.bottom,
      shrink = false,
      target,
    },
    ref
  ) => {
    const overlay = (ref as React.RefObject<HTMLElement>) || React.useRef(null)

    return (
      <Portal>
        <Anchor
          {...{
            canFlip,
            dependencies: [children],
            onLayout: anchor => {
              if (!overlay.current) return

              const left = Math.floor(anchor.left)
              const top = Math.floor(anchor.top)
              overlay.current.style.transform = `translateZ(0) translate(${left}px, ${top}px)`

              if (!shrink)
                overlay.current.style.minWidth = `${anchor.minWidth}px`
            },
            padding,
            placement,
            ref: overlay,
            target,
          }}
        >
          {children}
        </Anchor>
      </Portal>
    )
  }
)
